import { env } from 'src/env';

import styles from './QuestionItem.module.scss';
import { PaperPlaneRight } from '@phosphor-icons/react';
import { SVG_SIZE_M } from 'src/constants';

interface RelatedQuestionsItemProps {
  question: string;
}

export const QuestionItem = ({ question }: RelatedQuestionsItemProps) => {
  const handleClick = () => {
    const query = `${env.REACT_APP_NINJA_SHARED_URL}?query=${encodeURIComponent(
      question,
    )}`;

    window.open(query, '_blank');
  };

  return (
    <button onClick={handleClick} className={styles.root}>
      <span className={styles.content}>{question}</span>

      <span className={styles.icon}>
        <PaperPlaneRight size={SVG_SIZE_M} />
      </span>
    </button>
  );
};
